import React, { useState, useCallback } from 'react';
import { ITooltip, sendTooltipAnalytics } from './tooltip';
import Modal from '../modal';
import { useLocation } from '@gatsbyjs/reach-router';
import Button from '../button';
import useAnalytics from '../../../../hooks/useAnalytics';

export const TooltipPopup: React.FC<ITooltip> = ({
	children,
	className,
	icon,
	scroll,
	title,
	fieldname,
}) => {
	const [open, setOpen] = useState(false);
	const { href } = useLocation();
	const analytics = useAnalytics();
	const tag = title || fieldname || '';
	const sendAnalytics = useCallback(() => {
		sendTooltipAnalytics(analytics, href, tag);
	}, [analytics, href, tag]);

	return (
		<>
			<Button
				id={`${fieldname}`}
				onClick={(event: React.MouseEvent<HTMLElement>) => {
					sendAnalytics();
					event?.preventDefault();
					setOpen(true);
					return false;
				}}
				role={'tooltip'}
				type="button"
				className={className}>
				{icon}
			</Button>
			<Modal
				scroll={scroll}
				open={open}
				title={title}
				onClose={() => setOpen(false)}>
				{children}
			</Modal>
		</>
	);
};

export default TooltipPopup;
